/** Schedule / playback-plan API client (web) — player schedule endpoints. */
import { apiClient } from '../../../services/apiClient';
import type { ActiveScenarioDto, DayScheduleDto, PlaybackReportDto } from '../types';

const loc = (locationId: string) => `/api/v1/player/locations/${locationId}`;

export const getDaySchedule = (locationId: string, date?: string) =>
  apiClient.get<DayScheduleDto>(`${loc(locationId)}/schedule${date ? `?date=${date}` : ''}`);

export const generateSchedule = (locationId: string, date: string) =>
  apiClient.post<DayScheduleDto>(`${loc(locationId)}/schedule/generate?date=${date}`);

export const setScheduleItemExclusion = (
  locationId: string,
  scheduleItemId: string,
  date: string,
  excluded: boolean,
) =>
  apiClient.put<void>(`${loc(locationId)}/schedule/items/${scheduleItemId}/exclusion?date=${date}`, {
    excluded,
  });

export const getActiveScenarios = (locationId: string, date?: string) =>
  apiClient.get<ActiveScenarioDto[]>(
    `/api/v1/locations/${locationId}/scenarios/active${date ? `?date=${date}` : ''}`,
  );

export const reorderScenarios = (locationId: string, scenarioIds: string[]) =>
  apiClient.put<ActiveScenarioDto[]>(`/api/v1/locations/${locationId}/scenarios/reorder`, { scenarioIds });

export const getPlaybackReport = (locationId: string, date: string) =>
  apiClient.get<PlaybackReportDto>(`${loc(locationId)}/schedule/playback-report?date=${date}`);
